import React from "react";

import * as Grid from "@ui/Atoms/Grid";
import { Text } from "@ui/Atoms/Text";
import { TestWrapper } from "@ui/Atoms/TestWrapper";

import type { Props } from "./Section.types";
import * as Styled from "./Section.styled";

export const Section: React.FC<Props> = props => {
  return (
    <TestWrapper testId={props.testId}>
      <Styled.Root $bgColor={props.bgColor} $isDarkMode={props.isDarkMode}>
        <Grid.Container>
          <Grid.Row>
            <Grid.Column md={8} pushMd={1}>
              <Text as="h2" $style="bold_32">
                {props.heading}
              </Text>
            </Grid.Column>
          </Grid.Row>

          {!!props.description && (
            <Styled.Description>
              <Grid.Column md={7} pushMd={1}>
                <Text as="p" $style="regular_18">
                  {props.description}
                </Text>
              </Grid.Column>
            </Styled.Description>
          )}

          <Styled.Body>
            <Grid.Column md={10} pushMd={1}>
              {props.children}
            </Grid.Column>
          </Styled.Body>
        </Grid.Container>
      </Styled.Root>
    </TestWrapper>
  );
};
